import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import useSetOrg from '../components/hooks/useSetOrg';
import useUserInfo from '../components/hooks/useUserInfo';
import { useParams } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';
import { MarkContextProvider } from '../context/MarkContext';

import TopBar from '../components/common/TopBar';
import ExtractionBatchTransformedResults from '../components/extractionBatches/transformed/ExtractionBatchTransformedResults';
import useGetExtractionBatch from '../components/hooks/useGetExtractionBatch';
import ExtractionBatchHeader from '../components/extractionBatches/ExtractionBatchHeader';

const TransformedDataPage = () => {
  const { dpid, extractionBatchId, id } =
    useParams<Record<'dpid' | 'extractionBatchId' | 'id', string | undefined>>();

  const batchId = id || extractionBatchId;

  if (!dpid) {
    return <>Data Pool ID Required</>;
  }

  if (!batchId) {
    return <>Extraction Batch ID Required</>;
  }

  const { loading } = useSetOrg(dpid);
  const userInfo = useUserInfo();

  const { data: extractionBatch, isLoading: isLoadingExtractionBatch } = useGetExtractionBatch(
    dpid,
    batchId,
    true
  );

  useSetTitle(`Transformed - ${extractionBatch?.label || '...'}`);

  if (userInfo.isLoading || loading || isLoadingExtractionBatch) {
    return <LinearProgress />;
  }

  return (
    <MarkContextProvider>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <TopBar />

        <Box sx={{ bgcolor: '#F5F6FA', px: '40px', pt: '10px' }}>
          <ExtractionBatchHeader
            extractionBatch={extractionBatch}
            dpid={dpid}
            eid={batchId}
          />
        </Box>
        <Box sx={{ bgcolor: '#F5F6FA', px: '40px', py: '20px', flex: 1 }}>
          <ExtractionBatchTransformedResults extractionBatchId={batchId} />
        </Box>
      </Box>
    </MarkContextProvider>
  );
};

export default TransformedDataPage;
